module.exports = __webpack_public_path__ + "img/1_111@2x.b6f8cdc1.png";